// extracted by mini-css-extract-plugin
export var button = "source_code_window-module--button--S0F7+";
export var color_purple = "source_code_window-module--color_purple--A52gK";
export var disabledStyle = "source_code_window-module--disabledStyle--O3MuE";
export var isActive = "source_code_window-module--isActive--9Ha5p";
export var sourceCodeWindow = "source_code_window-module--sourceCodeWindow--WCfBm";
export var sourceCodeWrapper = "source_code_window-module--sourceCodeWrapper--ngnvu";
export var tab = "source_code_window-module--tab--2yxhP";
export var tabButtonWrapper = "source_code_window-module--tabButtonWrapper--GtyCy";
export var tabs = "source_code_window-module--tabs--spVi-";